import axios from 'axios'
import {toData} from "./util";

export function search(query, subsidiaryId): Promise {
  return axios.get(`/api/orders/search?query=${encodeURIComponent(query)}&subsidiaryId=${subsidiaryId}`).then(toData)
}

export function fetch(id): Promise {
  return axios.get(`/api/orders/${id}`).then(toData)
}

export function fetchLicensesByItemId(id): Promise {
  return axios.get(`/api/orders/licenses/${encodeURIComponent(id)}`).then(toData)
}

export function exportLicenses(navId): Promise {
  return axios.get(`/api/orders/export/${encodeURIComponent(navId)}`,{headers: {'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'},responseType: 'arraybuffer'},{})
}

export function blockLicensesByNavisionId(id, blocked): Promise {
  return axios.put(`/api/orders/licenses/${encodeURIComponent(id)}/${encodeURIComponent(blocked)}`).then(toData)
}
